import React, { ReactNode } from 'react';

import { useSiteMetadata } from '../../hooks/use-site-metadata';

interface Props {
  children?: ReactNode;
  title?: string;
  description?: string;
}

const SEO = ({ title, description, children }: Props) => {
  const { title: defaultTitle, description: defaultDescription } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {children}
    </>
  );
};

export default SEO;
